export const qbsGroups = {
  QBSOP: {
    id: 'QBSOP',
    order: 0,
    questions: {
      QBS01: {
        id: 'QBS01',
        order: 0,
      },
      QBS02: {
        id: 'QBS02',
        order: 1,
      },

      QBS03: {
        id: 'QBS03',
        order: 2,
      },
      QBS04: {
        id: 'QBS04',
        order: 3,
      },
    },
  },
  QBSSO: {
    id: 'QBSSO',
    order: 1,
    questions: {
      QBS05: {
        id: 'QBS05',
        order: 0,
      },

      QBS06: {
        id: 'QBS06',
        order: 1,
      },

      QBS07: {
        id: 'QBS07',
        order: 2,
      },
    },
  },
  QBSBI: {
    id: 'QBSBI',
    order: 2,
    questions: {
      QBS08: {
        id: 'QBS08',
        order: 0,
      },
      // QBS09: {
      //   id: 'QBS09',
      //   order: 1,
      // },

      QBS10: {
        id: 'QBS10',
        order: 2,
      },
    },
  },
  QBSEN: {
    id: 'QBSEN',
    order: 3,
    questions: {
      QBS11: {
        id: 'QBS11',
        order: 0,
      },
    },
  },
}

export type QBSTotalKey = 'QBSTT'
export type QBSGroupKey = keyof typeof qbsGroups
export type QBSQuestionKey =
  | keyof (typeof qbsGroups)['QBSOP']['questions']
  | keyof (typeof qbsGroups)['QBSSO']['questions']
  | keyof (typeof qbsGroups)['QBSBI']['questions']
  | keyof (typeof qbsGroups)['QBSEN']['questions']
export type QBSKey = QBSTotalKey | QBSGroupKey | QBSQuestionKey

export const isQBSGroupKey = (id: string): id is QBSGroupKey =>
  Object.keys(qbsGroups).includes(id)
export const isQBSQuestionKey = (id: string): id is QBSQuestionKey =>
  Object.keys(qbsGroups.QBSOP.questions).includes(id) ||
  Object.keys(qbsGroups.QBSSO.questions).includes(id) ||
  Object.keys(qbsGroups.QBSBI.questions).includes(id) ||
  Object.keys(qbsGroups.QBSEN.questions).includes(id)

export const isQBSKey = (id: string): id is QBSKey =>
  id === 'QBSTT' || isQBSGroupKey(id) || isQBSQuestionKey(id)
